import { createAction, props } from '@ngrx/store'

export const AppSubscribedComplete = createAction('[App] App Subscribed Complete', props<{ product: string }>())
